<template>
  <div class="tabs">
    <div
      :class="['trapezium', item.id === activityId ? 'activity' :'']"
      v-for="item in transformData"
      :key="item.id"
      @click="handleToggle(item.id)"
    >
      <div class="item"></div>
      <p class="no-select-text">{{item.label}}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    props: {
      type: Object,
      default: _ => ({ label: "name", id: "id" })
    },

    data: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      activityId: ""
    };
  },

  watch: {
    activityId: {
      handler(newValue, oldValue) {
        this.$emit("byActivityId", newValue);
      }
    }
  },

  computed: {
    transformData() {
      return this.data.map(item => ({
        label: item[this.props.label],
        id: item[this.props.id]
      }));
    }
  },

  methods: {
    handleToggle(id) {
      this.activityId = id;
    }
  }
};
</script>

<style scoped lang="scss">
.tabs {
  display: flex;
}
.trapezium {
  width: 120px;
  height: 60px;
  cursor: pointer;
  position: relative;
  transition: all 0.3s;

  &:nth-child(2) {
    transform: translateX(-4px);
  }

  &:nth-child(3) {
    transform: translateX(-8px);
  }

  &:nth-child(4) {
    transform: translateX(-12px);
  }

  .item {
    width: 100%;
    height: 100%;
    position: absolute;
    background: #fff;
    transform: perspective(40px) rotateX(20deg);
    transform-origin: bottom;
    border-radius: 10px 10px 5px 5px/10px 10px 8px 8px;
    box-shadow: 3px 3px 15px 0px rgba(0, 0, 0, 0.1);
    transition: all 0.3s;
  }
  p {
    width: 100%;
    height: 100%;
    position: absolute;
    font-size: 16px;
    padding-top: 30px;
    text-align: center;
  }
}

.activity {
  .item {
    background: #5d9cf2;
    box-shadow: 0px 3px 15px 0px rgba(43, 128, 244, 0.7);
  }

  p {
    color: #fff;
  }
}
</style>